export DsfNavTree from "./navTree.vue";
export DsfCheckNode from "./checkNode";

export const DsfTree = dsf.defineAsyncComponent("DsfTree", () => import(/* webpackChunkName: "plaftorm_tree_module" */ "./tree.vue"));
export const DsfTreeSelector = dsf.defineAsyncComponent("DsfTreeSelector", () => import(/* webpackChunkName: "plaftorm_tree_module" */ "./treeSelector.vue"));
export const DsfCustomDropTreeLogicNode = dsf.defineAsyncComponent("DsfCustomDropTreeLogicNode", () => import(/* webpackChunkName: "plaftorm_tree_module" */ "./drop/template/logicNode.js"));

export const DsfTreeInfo = dsf.defineLazyComponent("DsfTreeInfo", () => require("./treeInfo.vue"));
export const DsfCustomDropTree = dsf.defineLazyComponent("DsfCustomDropTree", () => require("./drop/customDropTree"));


